import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { UiStore } from '@pt/services';

import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'aa-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, HeaderComponent],
})
export class ShellComponent {
  readonly uiStore = inject(UiStore);
}
